import styled from 'styled-components';
import { Drawer, List, Typography } from 'antd';

const { Title } = Typography;

export const StyledDrawer = styled(Drawer)`
  width: 400px;
`;

export const StyledTitle = styled(Title)`
  && {
    margin: 0;
  }
`;

export const StyledList = styled(List)`
  width: 100%;

  && .ant-list-item {
    padding-inline: 12px;
  }
`;

export const StyledListItem = styled(List.Item)`
  width: 100%;
  cursor: pointer;
`;

export const StyledUnreadItem = styled(List.Item)`
  width: 100%;
  cursor: pointer;
  background: ${(props) => props.$background};
`;

export const StyledPageList = styled.div`
  flex: 1;
  overflow: auto;
`;

export const StyledPageRow = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 8px 24px 8px 12px;
  cursor: pointer;
`;

export const StyledPageFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
`;

export const StyledActions = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-bottom: 8px;
`;

export const StyledFooter = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 8px;
`;
